import { DIALOG_TYPE, LAUNCH_CALLER, LayoutConfig } from '@spartacus/storefront';
import { ExportShoppingListModalComponent } from './export-shopping-list-modal.component';

export const exportShoppingListModalLayoutConfig: LayoutConfig = {
  launch: {
    [LAUNCH_CALLER.EXPORT_SHOPPING_LIST]: {
      inlineRoot: true,
      component: ExportShoppingListModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
      dialogOptions: {
        onTop: true,
      },
    },
  },
};
